import { useEffect, useState } from "react";

import { detectNativeApp, supportsNativeSSO } from "@/lib/utils/tracking";

type NativeAppState = {
	/** Running inside one of the native app WebView wrappers */
	isNativeApp: boolean;
	/** The wrapper can complete SSO via an in-app browser popup */
	canUseNativeSSO: boolean;
};

/**
 * Detects whether the page is running inside the native app WebView.
 * Defaults to "native app" until mounted so webview users never see a
 * flash of SSO buttons; browser users get a one-frame flash-in instead.
 */
export function useIsNativeApp(): NativeAppState {
	const [state, setState] = useState<NativeAppState>({
		isNativeApp: true,
		canUseNativeSSO: false,
	});

	useEffect(() => {
		setState({
			isNativeApp: detectNativeApp(),
			canUseNativeSSO: supportsNativeSSO(),
		});
	}, []);

	return state;
}
